module.exports = __webpack_public_path__ + "img/pageP.ab011264.png";